import {
  IStandardDocumentCategoryData,
  IStandardDocumentCategoryOption,
} from './interfaces';
import { IUploadDocument } from '../upload/interfaces';
import { DateTime } from 'luxon';
import { DocumentCategoriesByName, IDocumentCategory, requiresGoodThroughDate } from '../IDocumentCategoryType';

type TStandardDocumentCategories = IStandardDocumentCategoryData | IStandardDocumentCategoryOption | IDocumentCategory;

export const categoryForDisplay = (
  standardDocumentCategories: TStandardDocumentCategories[],
  str: string
) => {
  const option = standardDocumentCategories.find((sd) => sd.label === str);
  return option ? option.label : '';
};

export const isDocumentReadyToUpload = (doc: IUploadDocument, categoriesByName: DocumentCategoriesByName): boolean => {
  const fileIsValid = !!doc.category;
  const isGoodThroughDateRequired = requiresGoodThroughDate(doc.category, categoriesByName);
  const goodThroughDate = doc.metadata ? doc.metadata.good_through_date : undefined;
  return isGoodThroughDateRequired
    ? !!goodThroughDate && DateTime.fromISO(goodThroughDate).isValid && fileIsValid
    : fileIsValid;
};
